import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  Routes,
} from "react-router-dom";
import AboutMe from "../components/AboutMe";
import Blogs from "../components/Blogs";
import Contact from "../components/Home/Contact";
import Main from "../components/Main/Main";
import Portfolio from "../components/Portfolio";
import Resume from "../components/Resume/Resume";

// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <Main />,
//     children: [
//       { path: "/", element: <AboutMe /> },
//       { path: "/resume", element: <Resume /> },
//       { path: "/blogs", element: <Blogs /> },
//       { path: "/contact", element: <Contact /> },
//       { path: "/work", element: <Portfolio /> },
//     ],
//   },
// ]);

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path="/"
      element={<Main />}
      // errorElement={<ErrorPage />}
    >
      <Route>
        <Route path="/" element={<AboutMe />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/work" element={<Portfolio />} />
      </Route>
    </Route>
  )
);

export default router;
